var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.layout==='default')?_c('OldLayout'):_c('new-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }